import React from "react";

import {
  Grid,
  Header,
  Button,
  Divider,
  Image,
  Icon,
  List,
  Tab,
  Container,
  Modal,
} from "semantic-ui-react";
import moment from "moment/moment";

import corn from "../Images/corn.jpg";
import bridge from "../Images/bridge_1.jpg";
import logo from "../Images/logo.png";

const Disclaimer = ({
  announcements,
  agree_url,
  terms_of_use_url,
  privacy_policy_url,
  parcelid,
}) => {
  // console.log({
  //   announcements,
  //   agree_url,
  //   terms_of_use_url,
  //   privacy_policy_url,
  //   parcelid,
  // });

  return (
    <div style={{ width: "100%", height: "100%", backgroundColor: "#CCC" }}>
      <div
        style={{
          height: "100%",
          width: "100%",
          backgroundImage: `url(${bridge})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: "FFFFFF",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Modal dimmer={"blurring"} size={"large"} open={true}>
          <Modal.Header>
            <Header as="h2" textAlign="center">
              Des Moines County GIS Mapping Application
            </Header>
          </Modal.Header>
          <Modal.Content>
            <Grid divided stackable>
              <Grid.Row>
                <Grid.Column width={10}>
                  <Header as="h3" textAlign="center">
                    Disclaimer
                  </Header>
                  {/* <Divider /> */}
                  <div
                    style={{
                      maxHeight: "250px",
                      overflowY: "auto",
                      padding: "0.5em",
                    }}
                  >
                    <p>
                      The GIS applications accessed through this web page
                      provide a visual display of data for your convenience.
                      Every reasonable effort has been made to assure the
                      accuracy of the maps and associated data. Des Moines
                      County makes no warranty, representation or guarantee as
                      to the content, sequence, accuracy, timeliness or
                      completeness of any of the data provided herein. The user
                      of these applications should not rely on the data provided
                      herein for any reason. Des Moines County explicitly
                      disclaims any representations and warranties, including,
                      without limitations, the implied warranties or
                      merchantability and fitness for a particular purpose. Des
                      Moines County shall assume no liability for any errors,
                      omissions, or inaccuracies in the information provided
                      regardless of how caused. Des Moines County shall assume
                      no liability for any decisions made or actions taken or
                      not taken by the user of the applications in reliance upon
                      any information or data furnished hereunder. To be sure of
                      complete accuracy, please check with County staff for
                      updated information.
                    </p>
                  </div>
                  <div style={{ textAlign: "center", margin: "1em 0" }}>
                    <a href={privacy_policy_url}>Privacy Policy</a> |{" "}
                    <a href={terms_of_use_url}>Terms of Use</a>
                  </div>
                  <Divider />
                  <div style={{ textAlign: "center" }}>
                    <Button>Cancel</Button>
                    <Button
                      primary
                      href={
                        parcelid
                          ? `${agree_url}?parcelid=${parcelid}`
                          : agree_url
                      }
                    >
                      Continue
                    </Button>
                  </div>
                </Grid.Column>
                <Grid.Column width={6}>
                  {announcements.length > 0 && (
                    <>
                      <Header as="h3" textAlign="center">
                        Announcements
                      </Header>
                      <Divider />
                      <List relaxed>
                        {announcements.map((record, index) => {
                          return (
                            <List.Item key={index}>
                              <List.Icon
                                name="angle right"
                                size="large"
                                verticalAlign="middle"
                              />
                              <List.Content>
                                <List.Header>{record.message}</List.Header>
                                <List.Description>
                                  {moment(record.createdAt).utc().format("LL")}
                                </List.Description>
                              </List.Content>
                            </List.Item>
                          );
                        })}
                      </List>
                    </>
                  )}

                  <Header as="h3" textAlign="center">
                    Related Links
                  </Header>
                  <Divider />
                  <List bulleted>
                    <List.Item href="#">Des Moines County Website</List.Item>
                    <List.Item href="#">Asessor's Office</List.Item>
                    <List.Item href="#">GIS Office</List.Item>
                  </List>
                  <Image
                    src={logo}
                    size="small"
                    style={{ margin: "3em auto" }}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Content>
        </Modal>
      </div>
    </div>
  );
};

export default Disclaimer;
